import type { OrgTrackConfig } from './GlobalTrack.types';

export enum SearchByOption {
  REFERENCE_NUMBER = 'referenceNumber',
  COURIER_PARTNER_REFERENCE_NUMBER = 'courierPartnerReferenceNumber',
  CUSTOMER_REFERENCE_NUMBER = 'customerReferenceNumber',
}

export const SEARCH_BY_TO_API_MAP: Record<SearchByOption, string> = {
  [SearchByOption.REFERENCE_NUMBER]: 'reference_number',
  [SearchByOption.COURIER_PARTNER_REFERENCE_NUMBER]: 'courier_partner_reference_number',
  [SearchByOption.CUSTOMER_REFERENCE_NUMBER]: 'customer_reference_number',
};

export const REFERENCE_NUMBER_SEPARATOR = ',';

export const GLOBAL_TRACK_PATH = '/p/track';

export const QUERY_PARAM = {
  SEARCH_BY: 'searchBy',
  REFERENCE_NUMBERS: 'refNum',
  CUSTOMER_CODE: 'customerCode',
  COURIER_PARTNER: 'courierPartner',
} as const;
export const SELF_COURIER_PARTNER_VALUE = 'SELF';

export const COURIER_PARTNER_MASTER_DATA_KEY = 'LTL_ORG_ACTIVE_DISTINCT_COURIER_PARTNERS';

export const CAPTCHA_ACTION = 'public_track';

export const CAPTCHA_READY_TIMEOUT_MS = 10000;

export const DEFAULT_ORG_TRACK_CONFIG: OrgTrackConfig = {
  hideLogo: false,
  hidePoweredByShipsy: false,
  hideSearchByPartnerNumber: false,
  hideSearchByCustomerReferenceNumber: false,
};

export const FAILURE_REASON_STATUSES = [
  'attempted',
  'not_picked_up',
  'pickup_failed',
  'rto_attempted',
  'cancelled',
] as const;
